/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AwsDeploymentImageConfig { 
    irr_ami_id?: string;
    irr_ami_name: string;
    cdvx_ami_id?: string;
    cdvx_ami_name: string;
    lambda_bucket_name: string;
}

